/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RecordingArchiveViewMode {
    Recordings = 0,
    Events = 1,
}
